import * as React from 'react';

import cx from 'classnames';

import { IconButton } from '@coursera/cds-core';
import type { IconButtonProps } from '@coursera/cds-core';

type Props = {
  selected?: boolean;
} & IconButtonProps;

/**
 * Rebrand CoachIconButton
 * Simple wrapper around CDS IconButton to provide Coach-specific styles.
 * Note: this should not be used outside of the parent `<CoachStylesProviderV2/>
 */
const CoachIconButtonV2 = (props: Props): React.ReactElement => {
  const { size = 'medium', selected = false, disabled, ...rest } = props;

  // use ariaDisabled when button is disabled but there is a tooltip
  // this allows users to focus/hover on the button to see the tooltip
  // while still keeping the underlying disabled styling for CDS IconButton
  const shouldAriaDisableOnly = disabled && !!rest.tooltip;

  return (
    <IconButton
      size={size}
      variant="ghost"
      className={cx('coach-icon-button-v2', { selected })}
      {...rest}
      aria-disabled={shouldAriaDisableOnly}
      disabled={!shouldAriaDisableOnly && disabled}
    />
  );
};

export default CoachIconButtonV2;
